var map = {
	"./asktug.svg": 9551,
	"./cloud-dev.svg": 5868,
	"./cloud1.svg": 5760,
	"./cloud2.svg": 9539,
	"./cloud3.svg": 8461,
	"./cloud4.svg": 5160,
	"./cloud5.svg": 8503,
	"./cloud6.svg": 3624,
	"./cloud7.svg": 7229,
	"./contributor.svg": 9313,
	"./deploy.svg": 3484,
	"./doc1.svg": 6174,
	"./doc10.svg": 6712,
	"./doc11.svg": 3079,
	"./doc2.svg": 404,
	"./doc3.svg": 2780,
	"./doc4.svg": 2060,
	"./doc5.svg": 379,
	"./doc6.svg": 7932,
	"./doc7.svg": 6912,
	"./doc8.svg": 2772,
	"./doc9.svg": 9251,
	"./docHome.svg": 4924,
	"./events.svg": 2787,
	"./go.svg": 7042,
	"./java.svg": 9267,
	"./maintain.svg": 780,
	"./ossinsight.svg": 1225,
	"./pablo-book-lover.svg": 8986,
	"./papers.svg": 6450,
	"./python.svg": 6030,
	"./tidb-banner.svg": 4969,
	"./tidb-cloud-banner.svg": 3306,
	"./tidb-cloud-tune.svg": 2430,
	"./users.svg": 795
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9907;